module.exports = "<app-nav></app-nav>\r\n<main class=\"container-fluid mt-0 pt-0 bg-light\">\r\n  <router-outlet></router-outlet>\r\n</main>\r\n"